module.exports = __webpack_public_path__ + "img/close.d2b72bd1.png";